module.exports = __webpack_public_path__ + "img/Jump Casting112.41e729a1.jpg";